/**
 * @type {BD_CFG}
 */
const CONFIG = {
    restURL: window.CFG?.restURL ?? "",
    themeURL: window.CFG?.themeURL ?? "",
    siteURL: window.CFG?.siteURL ?? "",
    nonce: window.CFG?.nonce ?? "",
    ajaxURL: window.CFG?.ajaxURL ?? "",
    current_language: window.CFG?.current_language ?? "",
    page_settings: window.CFG?.page_settings ?? {
        home: {
            general: {
                logo: "",
                subtitle: "",
            },
            steps: [],
        },
        timer: {
            general: {
                logo: "",
                subtitle: "",
            },
            button_label: {
                start: "",
                pause: "",
                resume: "",
                stop: "",
            },
            confirmation_popup: {
                header: "",
                title: "",
                subtitle: "",
                button_end_scene: "",
                button_cancel: "",
            },
        },
    },
    user_id: window.CFG?.user_id ?? 0,
};

export default CONFIG;
